const handleOveride = () => {
    // BSS_B2B.qb.priceOfEachItemElement = function (key) {
    //     return ['[bss-b2b-cart-item-key="' + key + '"][bss-b2b-item-final-price]']
    // };
    BSS_B2B.qb.totalPriceOfItemElement = function (key) {
        return ['[bss-b2b-cart-item-key="' + key + '"][bss-b2b-final-line-price]'];
    };
}
const id = setInterval(() => {
  if (BSS_B2B && BSS_B2B?.qb?.priceOfEachItemElement) {
    if (BSS_B2B.page.isCartPage()) handleOveride();
    clearInterval(id);
  }
}, 100);
setTimeout(() => clearInterval(id), 7000);
window.addEventListener("cart_changed", () => {
  BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false);
  BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
})


window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const handleCartCheckoutBtn = ({ shopData, checkoutButton, Tax }) => {
  const defaultBtnCheckout = $(checkoutButton).parent().find("button[name='checkout']:not(.bss-checkout)");
  if (defaultBtnCheckout.length > 0 && $(checkoutButton).parent().find(".bss-checkout").length) {
    defaultBtnCheckout.css("display", "none");
    $(".bss-checkout").css("display", "flex");
  }
};
window.BSS_B2B.addAction("fix_handle_cart_checkout_btn", handleCartCheckoutBtn);

setTimeout(() => {
  document.querySelectorAll(".cart__checkout-button").forEach(item => {
    item.style.opacity = "1";
    item.style.pointerEvents = "unset";
})
}, 4000)
